// src/docs/whitepaper.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const Whitepaper = () => {
  // Replace with the publicly accessible URL of your PowerPoint file
  const whitepaperUrl = "https://brokepiggytoken.xyz/wp-content/uploads/2025/03/CrowdLaunch-Whitepaper-v2.pptx";
  // Construct the Office Online embed URL (it must be URL-encoded)
  const embedUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(whitepaperUrl)}`;

  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Typography variant="h4" sx={{ color: "#FFD700", mb: 2 }}>
        CrowdLaunch Whitepaper
      </Typography>
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        Explore our detailed whitepaper to learn how CrowdLaunch is revolutionizing decentralized funding through on-chain tokenization and blockchain integration.
      </Typography>
      <Box sx={{ width: "100%", height: "600px" }}>
        <iframe
          title="CrowdLaunch Whitepaper"
          src={embedUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: "none" }}
        />
      </Box>
    </Container>
  );
};

export default Whitepaper;
